import { translatePrefix } from '../..';
import { SingleSelection } from '../../../../../components';
import { SelectChangeEvent } from '../../../../../components/MuiGenerals';
import { useTranslation } from '../../../../../hooks';
import useChains from '../../../../../hooks/useChains';

interface IProps {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  onClear: () => void;
  disabled?: boolean;
}

const ChainTypeSelect = (props: IProps) => {
  const { label, value, onChange, onClear, disabled } = props;
  const { t } = useTranslation(translatePrefix);
  const { chainList } = useChains();

  const createChainEnum = () => {
    const chainEnum: Record<string, string> = {};

    chainList.forEach((chain) => {
      const key = `${chain.displayName}`;
      const value = `${chain.id}`;
      chainEnum[key] = value;
    });

    return chainEnum;
  };

  const chainEnum = createChainEnum();

  return (
    <SingleSelection
      label={label || t('chain')}
      value={value}
      onChange={(e) => {
        onChange(e.target.value);
      }}
      clearSelect={onClear}
      enumData={chainEnum}
      nameFn={(name) => name}
      disabled={disabled}
    />
  );
};

export default ChainTypeSelect;
